import * as React from "react";
import { Alert } from "@mui/material";

export interface ITaskDynamicFormReferenceWarningProp {
    message: string;
}

export const TaskDynamicFormReferenceWarning = (props: ITaskDynamicFormReferenceWarningProp) => {
    return (
        <Alert severity="warning">
            {props.message}
        </Alert>
    );
};